export default function UmbracoFormsController(module) {
    angular.module(module || 'app')
        .controller('UmbracoFormsController', UmbracoFormsController);

    UmbracoFormsController.$inject = ['$window', '$scope', '$element', '$attrs', '$http', '$compile'];
    function UmbracoFormsController($window, $scope, $element, $attrs, $http, $compile) {
        var ctrl = this;
        ctrl.$onInit = function () {
            //if (!$rootScope.umbracoForms) {
            //    geolocation.getLocation('status,continentCode,countryCode,region,timezone', ctrl._apiKey)
            //        .then(function (userData) {
            //            $rootScope.umbracoForms = {
            //                region: userData.region,
            //                countryCode: userData.countryCode,
            //                timezone: userData.timezone
            //            };
            //        });
            //}
        };

        ctrl.goBack = () => {
            ctrl._goBack = true;
        }

        ctrl.submitForm = function ($event, isMultiStep, continueInModal) {
            $event.preventDefault();

            if (!ctrl.submitting) {
                ctrl.submitting = true;
                postForm(isMultiStep, continueInModal);
            }
        };

        function postForm(isMultiStep, continueInModal) {
            var valid = false;
            if (!ctrl._goBack) {
                $element.validate();
                valid = $element.valid();
                if (!valid) {
                    ctrl.submitting = false;
                }
            }

            if (ctrl._goBack || valid) {
                var values = $element.serializeArray();
                var data = new FormData();
                var jsonData = {};
                var jsonCheck = /^[\{\[]/
                values.forEach(function (item, index) {
                    data.append(item.name, item.value);
                    if (jsonData[item.name] === undefined) { // New
                        jsonData[item.name] = item.value ? (jsonCheck.test(item.value) ? JSON.parse(item.value) : item.value) : '';
                    } else {                            // Existing
                        if (!jsonData[item.name].push) {
                            jsonData[item.name] = [jsonData[item.name]];
                        }
                        jsonData[item.name].push(item.value || '');
                    }
                });

                if (ctrl._goBack) {
                    data.append('__prev', $element[0].querySelector('[name="__prev"]').innerText);
                }

                $.post({
                    method: 'POST',
                    url: location.pathname,
                    data: data,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        var html = document.createElement('html');
                        html.innerHTML = response;
                        var container = $element.parent();
                        var id = container.attr('id').replace('umbraco_form_', '');
                        var form = html.querySelector('#' + $element.parent().attr('id') + '> form');
                        var continueMessage = angular.element('#continue_prompt_' + id);
                        if (!form) {
                            var popup = $('#form_popup_' + id);
                            popup.foundation('open');
                            var pageForms = Array.from(document.querySelectorAll('#umbraco_form_' + id + ' form'));
                            if (continueMessage.length) {
                                continueMessage.css('display', 'none');
                            }
                            pageForms.forEach(pageForm => {
                                pageForm.reset();
                            });
                            if ($window.umbracoFormsData && $window.umbracoFormsData[id]) {
                                delete $window.umbracoFormsData[id];
                            }
                        }
                        else if (isMultiStep) {
                            if (!$window.umbracoFormsData) {
                                $window.umbracoFormsData = {};
                            }
                            var formData = $window.umbracoFormsData && $window.umbracoFormsData[id] ? $window.umbracoFormsData[id] : {};
                            formData = {
                                ...formData,
                                ...jsonData
                            };
                            $window.umbracoFormsData[id] = ctrl.formData = formData;
                            if (continueInModal) {
                                var modal = $('#form_step_' + id);
                                var modalForm;
                                var isClosed = modal.css('display') === 'none';
                                if (isClosed) {
                                    var formContainer = modal.find('.form-container');
                                    formContainer = modal.find('.form-container');
                                    formContainer.html(form.parentNode.parentNode.innerHTML);
                                    modalForm = formContainer.find('form');
                                    $compile(formContainer.contents())($scope.$parent);
                                    if (!modal._initialized) {
                                        modal.on('closed.zf.reveal', () => {
                                            if (continueMessage.length && $window.umbracoFormsData[id]) {
                                                continueMessage.css('display', '');
                                            }
                                        });
                                        modal._initialized = true;
                                    }
                                }
                                else {
                                    modalForm = modal.find('form');
                                    modalForm.html(form.innerHTML);
                                    $compile(modalForm.contents())($scope);
                                }
                                modalForm.removeData("validator").removeData("unobtrusiveValidation");
                                $.validator.unobtrusive.parse(modalForm);
                                if (isClosed) {
                                    modal.foundation('open');
                                }
                            }
                            else {
                                $element.html(form.innerHTML);
                                $compile($element.contents())($scope);
                                $element.removeData("validator").removeData("unobtrusiveValidation");
                                $.validator.unobtrusive.parse($element);
                            }
                        }
                        $scope.$evalAsync(function () {
                            ctrl.submitted = true;
                            ctrl.submitting = false;
                        });
                    },
                    error: function () {
                        $scope.$evalAsync(function () {
                            ctrl.submitting = false;
                        });
                    }

                });
            }
            ctrl._goBack = false;
        }

        ctrl.verifyCaptcha = function (token) {
            var verifyCaptchaResult =
                $http.get('/api/recaptcha/verify/', {
                    params: { token: token }
                })
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (response) {
                        console.log(response);
                        return false;
                    });
            return verifyCaptchaResult;
        };
    }
};